import { Box } from "@mui/material";

const RecordsBox = ({ items, itemsForSelection }) => {
  return (
    <Box>
      Enregistrements: ({(items && items.length) || 0})
      <Box component="span" sx={{ display: "inline-block", ml: 2 }}>
        {itemsForSelection.length === 0
          ? `Aucune sélection`
          : itemsForSelection.length === 1
            ? `${itemsForSelection.length} sélectionné`
            : `${itemsForSelection.length} sélectionnés`}
      </Box>
    </Box>
  );
};

export default RecordsBox;
